import React from 'react';

import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';

import type { BundleItem } from '../../../stores/rewards/types';
import { formatValueWithK } from '../../../utils/helpers';
import { BundleItemsRenderer } from '../../BundleItemsRenderer/BundleItemsRenderer';
import { CoinWithValue } from '../../CoinWithValue/CoinWithValue';
import classes from '../DailyMissions.module.scss';

export type GiftTooltipProps = {
  scCoin: number;
  gcCoin: number;
  bundleItems?: BundleItem[] | null;
};

export function GiftTooltip({ scCoin, gcCoin, bundleItems }: GiftTooltipProps) {
  const { t } = useTranslation();
  return (
    <div className={classes.giftTooltip}>
      <BundleItemsRenderer
        bundleItems={bundleItems || []}
        className={classes.dailyMissionsGiftTooltipBundleItems}
        direction={'vertical-v2'}
        frbWidgetWidth={55}
        snappyGiftWidgetWidth={30}
      />
      {!isEmpty(bundleItems) && scCoin > 0 ? <div className={classes.plus}>+</div> : null}
      {scCoin > 0 && (
        <CoinWithValue coinSide="left" coinType="SC">
          {scCoin}
        </CoinWithValue>
      )}
      {(!isEmpty(bundleItems) || scCoin > 0) && gcCoin > 0 && <div className={classes.plus}>+</div>}
      {gcCoin > 0 && (
        <CoinWithValue coinSide="left" coinType="GC">
          {formatValueWithK(gcCoin, t)}
        </CoinWithValue>
      )}
    </div>
  );
}
